import React from 'react';

function ProfileCollection(props) {
  return <h1 className="font-semibold text-4xl text-center">No collection</h1>;
}

export default ProfileCollection;
